/* unplugin-vue-components disabled */import script from "./user_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./user_detail.vue?vue&type=script&setup=true&lang=js"

import "./user_detail.vue?vue&type=style&index=0&id=725fe381&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725fe381"]])

export default __exports__